import React, { Component, createRef } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';

import IconChatHideWindow from '../../assets/icons/IconChatHideWindow';
import IconChatOpenWindow from '../../assets/icons/IconChatOpenWindow';
import IconChatMinimize from '../../assets/icons/IconChatMinimize';
import IconChatAttachment from '../../assets/icons/IconChatAttachment';
import IconChatMessageEmpty from '../../assets/icons/IconChatMessageEmpty';
import IconChatRoomEmpty from '../../assets/icons/IconChatRoomEmpty';
import IconChatScrollBottom from '../../assets/icons/IconChatScrollBottom';
import IconChatDelivered from '../../assets/icons/IconChatDelivered';
import IconChatRead from '../../assets/icons/IconChatRead';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faFileDownload, faSearch } from '@fortawesome/free-solid-svg-icons';

import { errorHandler } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { MESSAGE_TYPE_CONSTANT } from '../../constants/messageTypeConstant';
import { MESSAGE_STATUS_CONSTANT } from '../../constants/messageStatusConstant';
import { ADDITIONAL_KEY } from '../../constants/additionalKeyConstant';
import { formatBytes } from '../../util/htmlSpecialChar';
import ActionType from '../../redux/reducer/globalActionType';
import API_CHAT from '../../api/apiChat';
import IconPhone from '../../assets/icons/IconCall';
import { GroChatVoipContext } from '../GroChatVoipProvider/GroChatVoipProvider';

class ChatWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            smallWindow: false,
            roomList: {
                page: 1,
                limit: 100
            },
            messageList: {
                page: 1,
                limit: 100
            },
            listRoomChat: [],
            filteredRoomChat: [],
            activeRoomChat: {},
            listMessageChat: [],
            ticketNumber: '',
            message: '',
            file: '',
            attachment: {},
            showScrollButtom: false,
            isOnCall: false
        }
        this.chatWindowRef = createRef();
        this.textareaRef = React.createRef();

        /**
         * @type {React.RefObject<HTMLButtonElement>}
         */
        this.callButtonRef = createRef()

        this.websocket = null;
    }

    getListRoom = () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true') {
            API_CHAT.getListRoom(this.state.roomList.page, this.state.roomList.limit, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        const filteredData = res.data.data.filter(item => item.room_status === 'Active');
                        this.setState({
                            listRoomChat: filteredData,
                            filteredRoomChat: filteredData
                        });
                        this.handlePropsUnseenValue(filteredData);
                    }
                })
        }
    }

    getListMessage = roomId => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true') {
            API_CHAT.getListMessage(roomId, this.state.messageList.page, this.state.messageList.limit, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            listMessageChat: res.data.data.sort((a, b) => a.created_at - b.created_at),
                            ticketNumber: roomId.split('_')[1]
                        })
                        this.scrollToBottom();
                    }
                })
        }
    }

    postUploadAttachment = () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true') {
            const form = new FormData();
            form.append('file', this.state.file);

            API_CHAT.postUploadAttachment(form, this.props.token)
                .then(res => {
                    if (this._isMounted) {
                        this.setState({
                            attachment: res.data.data
                        }, () => {
                            this.handleSendAttachment();
                        });
                    }
                }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                    alert(err.response.data.description);
                }))
        }
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
        this.handleSendTyping(e.target.value === '');
    }

    handleChangeAttachment = e => {
        this.setState({
            file: e.target.files[0]
        }, () => {
            this.postUploadAttachment();
        });
    }

    handleClickRoom = data => {
        this.getListMessage(data.room_id);
        this.setState({
            smallWindow: false,
            activeRoomChat: data
        });
    }

    handleOpenDetailTicket = ticketNumber => {
        window.location.href = `${ROUTER_CONSTANT.TICKET_LIST_ALL}?searchBy=ticket.ticket_no&keyword=${ticketNumber}`;
    }

    handleSearchRoom = e => {
        const { listRoomChat } = this.state;
        const filteredRoomChat = listRoomChat.filter(ticket => ticket.room_id.split('_')[1].includes(e.target.value));
        this.setState({ filteredRoomChat });
    }

    handleTextareaKeyPress = e => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.setState({
                message: this.state.message.trim()
            }, () => {
                this.handleSendMessage();
            });
        } else if (e.key === 'Enter' && e.shiftKey) {
            const { selectionStart, selectionEnd, value } = this.textareaRef.current;
            this.textareaRef.current.value =
                value.substring(0, selectionStart) +
                '\n' +
                value.substring(selectionEnd);
            this.textareaRef.current.selectionStart = this.textareaRef.current.selectionEnd =
                selectionStart + 1;
            e.preventDefault();
        }
    };

    handleCheckIsImage = fileName => {
        const allowedExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
        const fileExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) return false;
        return true;
    }

    handleSendMessage = () => {
        if (this.state.message !== '') {
            let data = {
                type: 'chat',
                message: {
                    is_group: false,
                    source_id: this.props.userDetail.client_id,
                    destination_id: this.state.activeRoomChat.friend_client_id,
                    identity: {
                        client_id: this.props.userDetail.client_id,
                        sign: this.props.sign
                    },
                    message_detail: {
                        guarantee: true,
                        type: MESSAGE_STATUS_CONSTANT.SEND,
                        message_id: uuidv4(),
                        message_model: {
                            additional_key: '',
                            content: {
                                text: this.state.message
                            },
                            created_at: moment().tz("Asia/Jakarta").valueOf(),
                            deleted_type: 0,
                            is_broadcast: 0,
                            is_encrypted: 'N',
                            is_forward: 0,
                            local_id: 'local_id',
                            message_reply_id: '',
                            room_id: this.state.activeRoomChat.room_id,
                            type_message_id: MESSAGE_TYPE_CONSTANT.TEXT,
                            vector_x: this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_x ? this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_x + 1 : 1,
                            vector_y: this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_y ? this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_y : 0
                        }
                    }
                }
            }

            this.setState({ message: '' }, () => {
                this.props.websocket.send(JSON.stringify(data));
                this.scrollToBottom();
            })
        }
    };

    handleSendAttachment = () => {
        let data = {
            type: 'chat',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: this.state.activeRoomChat.friend_client_id,
                identity: {
                    client_id: this.props.userDetail.client_id,
                    sign: this.props.sign
                },
                message_detail: {
                    guarantee: true,
                    type: MESSAGE_STATUS_CONSTANT.SEND,
                    message_id: uuidv4(),
                    message_model: {
                        additional_key: this.handleCheckIsImage(this.state.attachment.file.name) ? ADDITIONAL_KEY.IMAGE : ADDITIONAL_KEY.DOCUMENT, // Pengecekan Tipe Jika Image atau File
                        content: {
                            text: '',
                            file: {
                                file: this.state.attachment.file,
                                thumb: this.state.attachment.thumb
                            }
                        },
                        created_at: moment().tz("Asia/Jakarta").valueOf(),
                        deleted_type: 0,
                        is_broadcast: 0,
                        is_encrypted: 'N',
                        is_forward: 0,
                        local_id: 'local_id',
                        message_reply_id: '',
                        room_id: this.state.activeRoomChat.room_id,
                        type_message_id: MESSAGE_TYPE_CONSTANT.FILE,
                        vector_x: this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_x ? this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_x + 1 : 1,
                        vector_y: this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_y ? this.state.listMessageChat[this.state.listMessageChat.length - 1].vector_y : 0
                    }
                }
            }
        }

        this.setState({ attachment: {} }, () => {
            this.props.websocket.send(JSON.stringify(data));
            this.scrollToBottom();
        })
    }

    handleShowScrollButtom = () => {
        if (this.chatWindowRef.current) {
            const currentHeight = this.chatWindowRef.current.scrollTop;
            const windowHeight = this.chatWindowRef.current.scrollHeight - this.chatWindowRef.current.clientHeight;
            if (currentHeight < windowHeight - 200) {
                return this.setState({ showScrollButtom: true });
            }
            return this.setState({ showScrollButtom: false });
        }
    }

    handleUpdateUnseenValue = () => {
        const updatedRoomsData = this.state.filteredRoomChat.map(room => {
            if (room.room_id === this.state.activeRoomChat.room_id) {
                return { ...room, unseen: 0 };
            }
            return room;
        });
        this.setState({ filteredRoomChat: updatedRoomsData });
        this.handlePropsUnseenValue(updatedRoomsData);
    };

    handlePropsUnseenValue = data => {
        let totalUnseen = 0;
        data.forEach((message) => {
            totalUnseen += message.unseen;
        });
        this.props.handleSetTotalUnseenMessage(totalUnseen);
    }

    scrollToBottom = () => {
        if (this.chatWindowRef.current) {
            this.chatWindowRef.current.scrollTop = this.chatWindowRef.current.scrollHeight;
            this.handleSeenMessage();
            setTimeout(() => {
                this.handleUpdateUnseenValue();
            }, 1000);
        }
    }

    handleListenNewMessage = message => {
        let isSender = message.message.source_id === this.props.userDetail.client_id;
        let newFormatData = {
            client_id: message.message.identity.client_id,
            message_id: message.message.message_detail.message_id,
            source_id: 0,
            room_id: 0,
            type_message_id: 1,
            message_reply_id: '',
            vector_x: message.message.message_detail.message_model.vector_x,
            vector_y: message.message.message_detail.message_model.vector_y,
            prev_vector_x: 0,
            prev_vector_y: 0,
            is_encrypted: 'N',
            is_forward: 0,
            is_broadcast: 0,
            created_at: message.message.message_detail.message_model.created_at,
            local_id: 'local_id',
            additional_key: message.message.message_detail.message_model.additional_key,
            content: {
                text: message.message.message_detail.message_model.content.text,
                file: message.message.message_detail.message_model.content.file
            },
            name: isSender ? this.props.userDetail.alias_name : '',
            room_key: message.message.message_detail.message_model.room_id
        }
        let isCorrectRoom = this.state.activeRoomChat.room_id === newFormatData.room_key;
        let isMessageDuplicate = this.state.listMessageChat.find(data => data.message_id === newFormatData.message_id);
        if (Object.keys(this.state.activeRoomChat).length > 0 && !isMessageDuplicate && isCorrectRoom) {
            return this.setState({
                listMessageChat: [
                    ...this.state.listMessageChat,
                    newFormatData
                ]
            }, () => {
                this.scrollToBottom();
            });
        }
    }

    handleSendTyping = isStopTyping => {
        const payload = {
            type: 'userTyping',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: this.state.activeRoomChat.friend_client_id,
                identity: {
                    client_id: '',
                    sign: ''
                },
                message_detail: {
                    message_id: '',
                    guarantee: false,
                    type: '',
                    message_model: {
                        typing_type: isStopTyping ? 0 : 1
                    }
                }
            }
        }
        return this.props.websocket.send(JSON.stringify(payload));
    }

    handleSeenMessage = () => {
        this.state.listMessageChat.forEach(data => {
            if (!data.client_id) return;
            const payload = {
                type: 'chat',
                message: {
                    is_group: false,
                    source_id: this.props.userDetail.client_id,
                    destination_id: this.state.activeRoomChat.friend_client_id,
                    identity: {
                        client_id: this.props.userDetail.client_id,
                        sign: this.props.sign
                    },
                    message_detail: {
                        guarantee: true,
                        type: MESSAGE_STATUS_CONSTANT.SEEN,
                        message_id: data.message_id,
                        message_model: {
                            additional_key: '',
                            content: {
                                text: ''
                            },
                            created_at: 0,
                            deleted_type: 0,
                            is_broadcast: 0,
                            is_encrypted: '',
                            is_forward: 0,
                            local_id: '',
                            message_reply_id: '',
                            room_id: data.room_key,
                            type_message_id: 0,
                            vector_x: 0,
                            vector_y: 0
                        }
                    }
                }
            }
            this.props.websocket.send(JSON.stringify(payload));
        })
    }

    handleTypeSend = (websocket, data) => {
        const payload = {
            type: 'chat',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: data.message.source_id,
                identity: {
                    client_id: this.props.userDetail.client_id,
                    sign: this.props.sign
                },
                message_detail: {
                    guarantee: true,
                    type: MESSAGE_STATUS_CONSTANT.DELIVERED,
                    message_id: data.message.message_detail.message_id,
                    message_model: {
                        additional_key: '',
                        content: {
                            text: ''
                        },
                        created_at: 0,
                        deleted_type: 0,
                        is_broadcast: 0,
                        is_encrypted: '',
                        is_forward: 0,
                        local_id: '',
                        message_reply_id: '',
                        room_id: data.message.message_detail.message_model.room_id,
                        type_message_id: 0,
                        vector_x: 0,
                        vector_y: 0
                    }
                }
            }
        }

        if (data.message.source_id === this.props.userDetail.client_id) {
            payload.message.message_detail.type = MESSAGE_STATUS_CONSTANT.ACK;
            payload.message.message_detail.message_id = data.message.message_detail.message_id;
            payload.message.destination_id = data.message.destination_id;
        }
        websocket.send(JSON.stringify(payload));
        this.handleListenNewMessage(data);
        this.getListRoom();
        return;
    }

    handleTypeDelivered = (websocket, data) => {
        if (data.message.source_id === this.props.userDetail.client_id) {
            return;
        }
        const payload = {
            type: 'chat',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: data.message.source_id,
                identity: {
                    client_id: this.props.userDetail.client_id,
                    sign: this.props.sign
                },
                message_detail: {
                    guarantee: true,
                    type: MESSAGE_STATUS_CONSTANT.ACKDElIVERED,
                    message_id: data.message.message_detail.message_id,
                    message_model: {
                        additional_key: '',
                        content: {
                            text: ''
                        },
                        created_at: 0,
                        deleted_type: 0,
                        is_broadcast: 0,
                        is_encrypted: '',
                        is_forward: 0,
                        local_id: '',
                        message_reply_id: '',
                        room_id: data.message.message_detail.message_model.room_id,
                        type_message_id: 0,
                        vector_x: 0,
                        vector_y: 0
                    }
                }
            }
        }
        return websocket.send(JSON.stringify(payload));
    }

    handleTypeSeen = (websocket, data) => {
        if (data.message.source_id === this.props.userDetail.client_id) {
            return;
        }
        const payload = {
            type: 'chat',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: data.message.source_id,
                identity: {
                    client_id: this.props.userDetail.client_id,
                    sign: this.props.sign
                },
                message_detail: {
                    guarantee: true,
                    type: MESSAGE_STATUS_CONSTANT.ACKSEEN,
                    message_id: data.message.message_detail.message_id,
                    message_model: {
                        additional_key: '',
                        content: {
                            text: ''
                        },
                        created_at: 0,
                        deleted_type: 0,
                        is_broadcast: 0,
                        is_encrypted: '',
                        is_forward: 0,
                        local_id: '',
                        message_reply_id: '',
                        room_id: data.message.message_detail.message_model.room_id,
                        type_message_id: 0,
                        vector_x: 0,
                        vector_y: 0
                    }
                }
            }
        }
        return websocket.send(JSON.stringify(payload));
    }

    handleChatWebsocket = (websocket, data) => {
        switch (data.message.message_detail.type) {
            case MESSAGE_STATUS_CONSTANT.SEND:
                this.handleTypeSend(websocket, data);
                break;
            case MESSAGE_STATUS_CONSTANT.DELIVERED:
                this.handleTypeDelivered(websocket, data);
                break;
            case MESSAGE_STATUS_CONSTANT.SEEN:
                this.handleTypeSeen(websocket, data);
                break;
            default:
                break;
        }
    }

    websocketSendMessage = (websocket, data) => {
        switch (data.type) {
            case 'chat':
                this.handleChatWebsocket(websocket, data);
                break;
            default:
                break;
        }
    };

    websocketHanshake = websocket => {
        const data = {
            client_id: this.props.userDetail.client_id,
            token: this.props.token,
            sign: this.props.sign
        }
        websocket.send(JSON.stringify(data));
    }

    websocketKeepAlive = websocket => {
        this.intervalKeepAlive = setInterval(() => {
            const data = {
                type: 'keepalive'
            }
            websocket.send(JSON.stringify(data));
        }, 120000);
    }

    initiateWebsocket = () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true') {
            const websocket = this.props.websocket;

            websocket.addEventListener('open', event => {
                this.websocketHanshake(websocket);
            })

            websocket.addEventListener('message', event => {
                this.websocketSendMessage(websocket, JSON.parse(event.data));
            })

            this.websocketKeepAlive(websocket);
        }
    }

    chatMessage = data => {
        if (data.additional_key === ADDITIONAL_KEY.IMAGE) {
            return (
                <>
                    <p className="max-w-xs truncate" title={data.content.file.file.name}>{data.content.file.file.name}</p>
                    <img src={data.content.file.file.cdnPath} alt={data.content.file.file.name} className="object-cover max-w-xs mb-1 cursor-pointer" onClick={() => window.open(data.content.file.file.cdnPath)} />
                </>
            )
        }
        if (data.additional_key === ADDITIONAL_KEY.AUDIO || data.additional_key === ADDITIONAL_KEY.VOICE_NOTE) {
            return (
                <>
                    <p className="max-w-xs truncate" title={data.content.file.file.name}>{data.content.file.file.name}</p>
                    <audio controls className="mb-1">
                        <source src={data.content.file.file.cdnPath} type={data.content.file.file.mimeType} />
                    </audio>
                </>
            )
        }
        if (data.additional_key === ADDITIONAL_KEY.VIDEO) {
            return (
                <>
                    <p className="max-w-xs truncate" title={data.content.file.file.name}>{data.content.file.file.name}</p>
                    <video controls className="object-cover w-80 h-60 mb-1">
                        <source src={data.content.file.file.cdnPath} type={data.content.file.file.mimeType} />
                    </video>
                </>
            )
        }
        if (data.additional_key === ADDITIONAL_KEY.DOCUMENT) {
            return (
                <>
                    <div className="flex items-center">
                        <div className="mr-2">
                            <p className="max-w-xs truncate" title={data.content.file.file.name}>{data.content.file.file.name}</p>
                            <p className="max-w-xs text-xs truncate" title={formatBytes(data.content.file.file.size)}>{formatBytes(data.content.file.file.size)}</p>
                        </div>
                        <div className="h-8 w-8 flex justify-center items-center border border-gray-600 rounded-full cursor-pointer">
                            <FontAwesomeIcon icon={faFileDownload} className="text-lg" onClick={() => window.open(data.content.file.file.cdnPath)} />
                        </div>
                    </div>
                </>
            )
        }
        return (
            <p className="max-w-xs">{data.content.text}</p>
        )
    }

    lastChatMessage = data => {
        if (data.message.additional_key === ADDITIONAL_KEY.IMAGE
            || data.message.additional_key === ADDITIONAL_KEY.AUDIO
            || data.message.additional_key === ADDITIONAL_KEY.VIDEO
            || data.message.additional_key === ADDITIONAL_KEY.VOICE_NOTE
            || data.message.additional_key === ADDITIONAL_KEY.DOCUMENT) {
            return data.message.content.file.file.name;
        }
        return data.message.content.text;
    }

    handleCall = async () => {
        this.callButtonRef.current.disabled = true

        if (!this.state.activeRoomChat || Object.keys(this.state.activeRoomChat).length === 0) {
            this.callButtonRef.current.disabled = false
            return
        }

        const roomId = this.state.activeRoomChat.room_id
        const clientIdToCall = this.state.activeRoomChat.friend_client_id
        const ticketNumber = roomId.split('_')[1]

        const groChatVoipContext = this.getGroChatVoipContext()
        groChatVoipContext.setRecordingFileName()

        if (ticketNumber) {
            groChatVoipContext.setContext("ticketNo", ticketNumber)
            groChatVoipContext.setRecordingFileName(`${ticketNumber}.mp3`)
        }

        try {
            await groChatVoipContext.call(clientIdToCall)
        } catch (err) {
            if (err instanceof DOMException) {
                alert('Mohon aktifkan izin mikrofon untuk melakukan panggilan')
                this.callButtonRef.current.disabled = false
            }
        }
    }

    /**
     * @returns {React.ContextType<GroChatVoipContext>}
     */
    getGroChatVoipContext = () => {
        return this.context
    }

    componentDidMount() {
        this._isMounted = true;
        this.getListRoom();

        const ctx = this.getGroChatVoipContext()

        ctx.onCallEnded(() => {
            if (this.callButtonRef.current) {
                this.callButtonRef.current.disabled = false
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.websocket !== this.props.websocket) {
            this.initiateWebsocket();
        }
        if (localStorage.getItem('openRoomChat') === 'true') {
            if (!this.props.showChatWindow) {
                this.setState({
                    activeRoomChat: {},
                    listMessageChat: []
                });
                this.props.handleShowChatWindow();
            }
            localStorage.removeItem('openRoomChat');
        }
        if (localStorage.getItem('closeRoomChat') === 'true') {
            this.setState({
                activeRoomChat: {},
                listMessageChat: []
            });
            setTimeout(() => {
                this.getListRoom();
            }, 1500);
            localStorage.removeItem('closeRoomChat');
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        clearInterval(this.intervalKeepAlive);
    }

    render() {
        const ctx = this.getGroChatVoipContext()

        return (
            <div className={`${this.state.smallWindow ? 'chat-window-small' : 'chat-window'} ${this.props.className} shadow rounded-lg overflow-hidden`}>
                <ReactTooltip
                    id="chatwindow"
                    place="top"
                    type="info"
                    effect="solid"
                />

                <div className="chat-header handle bg-chat-header-window flex justify-between items-center px-5">
                    <p className="text-2xl text-white font-medium">Chat</p>
                    <div className="flex items-center space-x-5">
                        { 
                            (this.state.activeRoomChat && Object.keys(this.state.activeRoomChat).length > 0) 
                                && (
                                <>
                                    <ReactTooltip
                                        id="chatwindow2"
                                        place="top"
                                        type="info"
                                        effect="solid"
                                    />
                                    <button
                                        className={ctx.getCall() ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
                                        data-tip={ctx.getCall() ? "" : "Panggil"}
                                        data-for="chatwindow2"
                                        onClick={this.handleCall}
                                        ref={this.callButtonRef}
                                    >
                                        <IconPhone />
                                    </button>
                                </>
                                )
                        }
                        <div
                            className="cursor-pointer"
                            data-tip={this.state.smallWindow ? "Besarkan" : "Kecilkan"}
                            data-for="chatwindow"
                            onClick={() => this.setState({ smallWindow: !this.state.smallWindow })}
                        >
                            {this.state.smallWindow ? <IconChatOpenWindow /> : <IconChatHideWindow />}
                        </div>
                        <div
                            className="cursor-pointer"
                            data-tip="Sembunyikan"
                            data-for="chatwindow"
                            onClick={this.props.handleShowChatWindow}
                        >
                            <IconChatMinimize />
                        </div>
                    </div>
                </div>
                {
                    this.state.listRoomChat.length > 0
                        ? <div className="chat-body text-gray-600 flex items-center">
                            <div className={this.state.smallWindow ? "hidden" : "chat-left block border-r border-gray-200 relative"}>
                                {
                                    this.state.listMessageChat.length > 0 && Object.keys(this.state.activeRoomChat).length > 0
                                        ? <>
                                            <div className="chat-body-header flex justify-between items-center bg-white border-b border-gray-200 p-3">
                                                {
                                                    this.state.ticketNumber !== '' &&
                                                    <>
                                                        <p className="font-medium">{this.state.ticketNumber}</p>
                                                        <p className="text-darkred cursor-pointer select-none" onClick={() => this.handleOpenDetailTicket(this.state.ticketNumber)}>Lihat Detail Tiket <FontAwesomeIcon icon={faChevronRight} /></p>
                                                    </>
                                                }
                                            </div>
                                            <div className="relative">
                                                <div className="chat-container flex flex-col overflow-auto scroll-smooth p-3" ref={this.chatWindowRef} onScroll={this.handleShowScrollButtom}>
                                                    {
                                                        this.state.listMessageChat.map((data, idx) =>
                                                            <div className={data.client_id === this.props.userDetail.client_id ? "chat-bubble-right" : "chat-bubble-left"} key={idx}>
                                                                <p className={data.client_id === this.props.userDetail.client_id ? "hidden" : "text-olddarkblue font-medium"}>{data.name}</p>
                                                                {this.chatMessage(data)}
                                                                <div className="flex items-center float-right space-x-1">
                                                                    <p className={data.client_id === this.props.userDetail.client_id ? "block" : "hidden"}>
                                                                        {data?.seenBy?.length > 0 ? <IconChatRead /> : <IconChatDelivered />}
                                                                    </p>
                                                                    <p className="text-xs" title={moment(data.created_at).format('DD/MM/YYYY HH:mm')}>{moment(data.created_at).format('HH:mm')}</p>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                <button type="button" className={this.state.showScrollButtom ? "absolute right-3 bottom-3 opacity-100 transition-all duration-200 transform translate-y-0" : "absolute right-3 bottom-3 opacity-0 pointer-events-none transition-all duration-200 transform translate-y-5"} onClick={this.scrollToBottom}>
                                                    <IconChatScrollBottom />
                                                </button>
                                            </div>
                                            <div className="chat-body-footer flex justify-between items-center bg-lightgrey space-x-3 p-3">
                                                <textarea
                                                    className="form-control resize-none h-11"
                                                    onChange={this.handleChange}
                                                    onKeyDown={this.handleTextareaKeyPress}
                                                    placeholder="Ketik Pesan"
                                                    value={this.state.message}
                                                    name="message"
                                                    ref={this.textareaRef}
                                                    autoFocus
                                                />
                                                <div className="flex items-center space-x-3">
                                                    {/* <div className="cursor-pointer"><IconChatEmoji /></div> */}
                                                    <label htmlFor="fupattachment" className="cursor-pointer">
                                                        <IconChatAttachment />
                                                    </label>
                                                    <input type="file" name="file" id="fupattachment" className="hidden" onChange={this.handleChangeAttachment} />
                                                </div>
                                            </div>
                                        </>
                                        : <div className="flex flex-col justify-center items-center h-full">
                                            <IconChatMessageEmpty />
                                            <p className="text-xl text-black font-medium">Selamat Datang di Fitur Chat</p>
                                            <p className="text-gray-400">Pilih pesan di samping untuk mulai chat dengan pelanggan</p>
                                        </div>
                                }
                            </div>
                            <div className="chat-right">
                                <div className="chat-search flex items-center shadow relative p-3">
                                    <input type="text" className="custom-form-control w-full h-full pl-3 pr-10" placeholder="Cari Tiket" onChange={this.handleSearchRoom} />
                                    <FontAwesomeIcon icon={faSearch} className="absolute right-7 text-gray-500" />
                                </div>
                                <div className="chat-list overflow-auto">
                                    {
                                        this.state.filteredRoomChat.map((data, idx) =>
                                            data.message &&
                                            <div className={`${data.room_id === this.state.activeRoomChat.room_id ? 'chat-list-item-active' : 'chat-list-item'}  flex items-center justify-between space-x-3 border-b border-gray-200 cursor-pointer select-none p-3`} key={idx} onClick={() => this.handleClickRoom(data)}>
                                                <div className="h-5 w-5 flex justify-center items-center bg-initial-name-blue rounded-full text-sm">
                                                    C
                                                </div>
                                                <div className="w-3/5">
                                                    <p className="font-medium">{data.name.split('_')[1]}</p>
                                                    <p className="truncate" title={data.message && this.lastChatMessage(data)}>{data.message && this.lastChatMessage(data)}</p>
                                                </div>
                                                <div className="flex flex-col items-end">
                                                    <p className={`${data.unseen > 0 ? 'opacity-1' : 'opacity-0'} h-5 w-5 flex justify-center items-center bg-darkred rounded-full text-sm text-white`}>{data.unseen}</p>
                                                    <p className="text-sm text-right" title={data.message && moment(data.message.created_at).format('DD/MM/YYYY HH:mm')}>{data.message && moment(data.message.created_at).format('DD/MM/YY HH:mm')}</p>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        : <div className="chat-body flex flex-col justify-center items-center">
                            <IconChatRoomEmpty />
                            <p className="text-xl font-medium">Tidak Ada Pesan</p>
                            <p className="text-gray-400">Tidak ada pesan yang masuk di jendela obrolan ini</p>
                        </div>
                }
            </div>
        );
    }
}

ChatWindow.contextType = GroChatVoipContext

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        sign: state.authentication.sign,
        userDetail: state.authentication.userDetail,
        websocket: state.grochatWebsocket.websocket
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChatWindow));